<template>
  <b-modal
    id="dejavoo-partial-approval-modal"
    hide-footer
    hide-header
    modal-class="partial-approval-popup"
    centered
    no-fade
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="modal-card">
      <div class="modal-header-custom">
        <div class="icon-wrapper">
          <svg class="icon icon-icon-popup-cansel"><use xlink:href="#icon-icon-popup-cansel" /></svg>
        </div>
        <h2 class="modal-title">
          Partial Payment
        </h2>
      </div>

      <p class="summary-text">
        The transaction was partially approved for the amount below.
      </p>

      <div class="amount-summary">
        <div class="amount-row">
          <span class="label">Approved Amount:</span>
          <span class="value approved">${{ approvedAmount.toFixed(2) }}</span>
        </div>
        <div class="amount-row">
          <span class="label">Remaining Balance:</span>
          <span class="value remaining">${{ remainingBalance.toFixed(2) }}</span>
        </div>
      </div>

      <div class="modal-actions">
        <b-button
          variant="outline-danger"
          @click="voidTransaction"
          :disabled="isVoiding"
          class="action-button"
        >
          <span v-if="!isVoiding">Void Payment</span>
          <span v-else>Voiding...</span>
        </b-button>
        <b-button
          variant="primary"
          @click="continueToPay"
          :disabled="isVoiding"
          class="action-button"
        >
          Pay Remaining Balance
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "DejavooPartialApprovalModal",
  props: {
    approvedAmount: {
      type: Number,
      required: true,
      default: 0
    },
    remainingBalance: {
      type: Number,
      required: true,
      default: 0
    },
    isVoiding: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    continueToPay() {
      this.$emit('continue-to-pay');
    },
    voidTransaction() {
      this.$emit('void-transaction');
    }
  }
}
</script>

<style scoped lang="scss">
.modal-card {
  padding: 1.5rem;
  text-align: center;
}

.modal-header-custom {
  margin-bottom: 1rem;

  .icon-wrapper {
    margin: 0 auto 1rem;
    .icon {
        width: 48px;
        height: 48px;
    }
  }

  .modal-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #343a40;
  }
}

.summary-text {
  font-size: 1rem;
  color: #6c757d;
  margin-bottom: 1.5rem;
}

.amount-summary {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1.5rem;
  text-align: left;

  .amount-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1rem;

    &:not(:last-child) {
      margin-bottom: 0.75rem;
    }

    .label {
      color: #495057;
    }

    .value {
      font-weight: 700;
      font-size: 1.1rem;
      &.approved {
        color: #28a745;
      }
      &.remaining {
        color: #dc3545;
      }
    }
  }
}

.modal-actions {
  display: flex;
  gap: 1rem;

  .action-button {
    flex: 1;
    height: 50px;
    font-size: 1rem;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
  }
}

::v-deep .partial-approval-popup .modal-dialog {
  max-width: 450px;
}

::v-deep .partial-approval-popup .modal-body {
  padding: 0;
}
</style>

